import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-small-success-button',
  templateUrl: './small-success-button.component.html',
  styleUrls: ['./small-success-button.component.css']
})
export class SmallSuccessButtonComponent {


  @Input() icon: string;
  @Input() buttonText: string;
  @Input() text: string;

  constructor() { }


}
